'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTrendingItemsByBids = exports.getMostPopularItemsByBids = exports.getMyAuctions = exports.getSellerCatalogs = exports.getMySavedSearchItems = exports.getMySavedItems = exports.getMyBids = exports.getFollowedSellers = exports.getLiveCatalogItems = exports.getCatalogItems = undefined;

var _sorting = require('./sorting');

var _cardData = require('../modules/cardData');

var _item = require('../modules/item');

var _catalogRegistration = require('../modules/catalogRegistration');

var _catalog = require('../modules/catalog');

var _followSeller = require('../modules/followSeller');

var _biddingInfo = require('../modules/biddingInfo');

var _savedSearchItem = require('../modules/savedSearchItem');

var _saveItem = require('../modules/saveItem');

var getCatalogItems = exports.getCatalogItems = function getCatalogItems(state, catalogId) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        count = _ref.count,
        page = _ref.page,
        sort = _ref.sort,
        terms = _ref.terms;

    var ids = (0, _item.getItemIdsForCatalog)(state, catalogId);
    var all = (0, _cardData.getItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getLiveCatalogItems = exports.getLiveCatalogItems = function getLiveCatalogItems(state, catalogId) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        count = _ref2.count,
        page = _ref2.page,
        sort = _ref2.sort,
        terms = _ref2.terms;

    var ids = (0, _item.getItemIdsForCatalog)(state, catalogId);
    var all = (0, _cardData.getLiveItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getFollowedSellers = exports.getFollowedSellers = function getFollowedSellers(state) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref3.count,
        page = _ref3.page,
        sort = _ref3.sort,
        terms = _ref3.terms;

    var ids = (0, _followSeller.getFollowedSellerIds)(state);
    var all = (0, _cardData.getSellerCardDatas)(state, ids);
    return (0, _sorting.filterSellers)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getMyBids = exports.getMyBids = function getMyBids(state) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref4.count,
        page = _ref4.page,
        sort = _ref4.sort,
        terms = _ref4.terms,
        tab = _ref4.tab;

    var ids = (0, _biddingInfo.getMyBidItemIds)(state);
    var all = (0, _cardData.getItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, tab: tab, terms: terms });
};

var getMySavedItems = exports.getMySavedItems = function getMySavedItems(state) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref5.count,
        page = _ref5.page,
        sort = _ref5.sort,
        terms = _ref5.terms;

    var ids = (0, _saveItem.getSortedSavedItemIdsFromState)(state);
    var all = (0, _cardData.getItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getMySavedSearchItems = exports.getMySavedSearchItems = function getMySavedSearchItems(state) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref6.count,
        page = _ref6.page,
        sort = _ref6.sort,
        terms = _ref6.terms;

    var ids = (0, _savedSearchItem.getSavedSearchItemIds)(state);
    var all = (0, _cardData.getItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getSellerCatalogs = exports.getSellerCatalogs = function getSellerCatalogs(state, sellerId) {
    var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        count = _ref7.count,
        page = _ref7.page,
        sort = _ref7.sort,
        tab = _ref7.tab,
        terms = _ref7.terms;

    var ids = (0, _catalog.getCatalogIdsForSeller)(state, sellerId);
    var all = (0, _cardData.getCatalogCardDatas)(state, ids);
    return (0, _sorting.filterCatalogs)(all, { count: count, page: page, sort: sort, tab: tab, terms: terms });
};

var getMyAuctions = exports.getMyAuctions = function getMyAuctions(state) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref8.count,
        page = _ref8.page,
        sort = _ref8.sort,
        terms = _ref8.terms,
        tab = _ref8.tab;

    var catalogIds = (0, _catalogRegistration.getAllUserCatalogRegistrationIds)(state);
    var all = (0, _cardData.getCatalogCardDatas)(state, catalogIds);
    return (0, _sorting.filterCatalogsByReg)(state, all, { count: count, page: page, sort: sort, tab: tab, terms: terms });
};

var getMostPopularItemsByBids = exports.getMostPopularItemsByBids = function getMostPopularItemsByBids(state, sellerId) {
    var ids = (0, _item.getItemIdsForSeller)(state, sellerId);
    var all = (0, _cardData.getItemCardDatas)(state, ids);

    var _filterItems = (0, _sorting.filterItems)(all, { count: 20, page: 1, sort: 'MOST_BIDS', tab: 'upcoming' }),
        items = _filterItems.items;

    return items || [];
};

var getTrendingItemsByBids = exports.getTrendingItemsByBids = function getTrendingItemsByBids(state, trendingItemIds, count) {
    var trendingItems = (0, _cardData.getItemCardDatas)(state, trendingItemIds);

    var _filterItems2 = (0, _sorting.filterItems)(trendingItems, {
        count: count,
        page: 1,
        sort: 'MOST_BIDS',
        tab: 'upcoming'
    }),
        items = _filterItems2.items;

    return items || [];
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/filteredItems.js
// module id = IeGF
// module chunks = 57